module.exports = __webpack_public_path__ + "img/63.d229eeb4.png";